import { render, staticRenderFns } from "./AvatarUpdate.vue?vue&type=template&id=0470f0e2"
import script from "./AvatarUpdate.vue?vue&type=script&lang=js"
export * from "./AvatarUpdate.vue?vue&type=script&lang=js"
import style0 from "./AvatarUpdate.vue?vue&type=style&index=0&id=0470f0e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports